
var Banners = function()
{

	this.slide = function()
	{

		var app = this;

		this.updateSlideRows = function( response )
		{

		};

		return new function()
		{

			var bindEvents = function()
			{

			};

			this.init = function()
			{
				bindEvents();
				$.fn.ensphere.veto.wysiwyg( '.redactor' );
			};

		};
	}

	this.banner = function()
	{

		return new function()
		{

			var sorter = function(){
				$('.orderable').rowSorter({
					onDrop: function( tbody, row, new_index, old_index ) {
				        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
				        var ids = [];
				        $('tbody tr', table).each(function(){
				        	ids.push( $(this).attr('data-field-id') );
				        });
				        $.ajaxSetup({
				            headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
				        });
				        $.post( $('#order-url').val(), { orders : ids }, function( response ){
				        	console.log(response);
				        });
				    },
				});
			};

			var bindEvents = function()
			{

			};

			this.init = function()
			{
                bindEvents();
				sorter();
			};

		};

	};

};


jQuery(document).ready( function($){


	var app = new Banners();

	if( $('.create.banner-slide, .edit.banner-slide').length ) {
		var slide = app.slide();
		slide.init();
	}

	if( $('.create.banner, .edit.banner').length ) {
		var banner = app.banner();
		banner.init();
	}

});
